import React, { useContext } from 'react';
import classnames from 'classnames';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { scaleToSize, isFileTiny } from '../../../_helpers';
import s from './ContentShadow.scss';
export const ContentShadow = ({ content , containerSize , children , useSmallStage , className  })=>{
    const isMobile = useContext(MobileContext);
    const shadowSize = scaleToSize(content, containerSize);
    const needsSmallStage = useSmallStage && isFileTiny(content, isMobile);
    if (!shadowSize || content.transparency) {
        return /*#__PURE__*/ React.createElement("div", {
            className: classnames(needsSmallStage && s['small-stage'], className)
        }, children);
    }
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        style: needsSmallStage ? {} : shadowSize,
        className: classnames(needsSmallStage && s['small-stage'], className)
    }, children), !needsSmallStage && /*#__PURE__*/ React.createElement("div", {
        style: shadowSize,
        className: s['shadow-anchor']
    }));
};
ContentShadow.displayName = 'ContentShadow';
export default ContentShadow;
